import * as tslib_1 from "tslib";
import { AssetEvent } from "@awayjs/core";
import { BlendMode } from "@awayjs/graphics";
import { ContextGLCompareMode, ShaderBase, GL_MaterialPassBase } from "@awayjs/stage";
/**
 * GL_SkyboxMaterial forms an abstract base class for the default shaded materials provided by Stage,
 * using material methods to define their appearance.
 */
var GL_SkyboxMaterial = (function (_super) {
    tslib_1.__extends(GL_SkyboxMaterial, _super);
    function GL_SkyboxMaterial(skybox, materialPool) {
        var _this = _super.call(this, skybox, materialPool) || this;
        _this._skybox = skybox;
        _this._shader = new ShaderBase(materialPool.elementsClass, _this, _this._stage);
        _this._texture = _this._shader.getAbstraction(_this._skybox.texture);
        _this._pAddPass(_this);
        return _this;
    }
    GL_SkyboxMaterial.prototype.onClear = function (event) {
        _super.prototype.onClear.call(this, event);
        this._texture.onClear(new AssetEvent(AssetEvent.CLEAR, this._skybox.texture));
        this._texture = null;
        this._skybox = null;
    };
    /**
     * @inheritDoc
     */
    GL_SkyboxMaterial.prototype._pUpdateRender = function () {
        _super.prototype._pUpdateRender.call(this);
        this._pRequiresBlending = (this._material.blendMode != BlendMode.NORMAL);
        this.shader.setBlendMode((this._material.blendMode == BlendMode.NORMAL && this._pRequiresBlending) ? BlendMode.LAYER : this._material.blendMode);
    };
    GL_SkyboxMaterial.prototype._includeDependencies = function (shader) {
        _super.prototype._includeDependencies.call(this, shader);
        shader.usesPositionFragment = true;
    };
    /**
     * @inheritDoc
     */
    GL_SkyboxMaterial.prototype._getFragmentCode = function (registerCache, sharedRegisters) {
        return this._texture._getFragmentCode(sharedRegisters.shadedTarget, registerCache, sharedRegisters, sharedRegisters.positionVarying);
    };
    GL_SkyboxMaterial.prototype._setRenderState = function (renderable, projection) {
        _super.prototype._setRenderState.call(this, renderable, projection);
        this._texture._setRenderState(renderable);
    };
    /**
     * @inheritDoc
     */
    GL_SkyboxMaterial.prototype._activate = function (projection) {
        _super.prototype._activate.call(this, projection);
        this._stage.context.setDepthTest(false, ContextGLCompareMode.LESS);
        this._texture.activate();
    };
    return GL_SkyboxMaterial;
}(GL_MaterialPassBase));
export { GL_SkyboxMaterial };



// WEBPACK FOOTER //
// ../dist/lib/materials/GL_SkyboxMaterial.js